
<template>
  <div :class="$options.name">
    <el-upload v-show="!uploadimg.resimg" class="upload-el" accept="image/*" ref="fileUpload" name="file"
      :action="uploadurl" :data="uploadimg.uploaddata" :on-change="selectChange" :show-file-list="false"
      :auto-upload="false" :http-request="httpRequest" :file-list="fileList" :limit="1">
      <div>
        <span class="icon upload-icon" />
        <el-button>上传图片</el-button>
      </div>
      <div slot="tip" class="el-upload__tip">
        图片大小不超过2M
      </div>
    </el-upload>
    <figure   class="result-img">
      <!-- <img :src="decodeURIComponent(uploadimg.resimg)" /> -->
      <!-- <el-button @click="updateCropper">重新上传</el-button> -->
    </figure>
    <cropper v-if="showCropper" :dialog-visible="showCropper" :cropper-img="cropperImg" @update-cropper="updateCropper"
      @colse-dialog="closeDialog" @upload-img="uploadImg" />
  </div>
</template>

<script>
import Cropper from "./cropper.vue";
import axios from "axios";
import baseAxios from "./common/axios";
import { loading } from "./common";
import { getToken } from "@/utils/auth";
import { Encrypt, Decrypt } from '@/utils/index.js'
import { SHA256 } from 'crypto-js'
export default {
  name: "UploadImg",
  components: {
    Cropper,
  },
  props: {
    uploadimg: {
      type: Object,
      default: () => {
        return {
          uploadurl:
            "",
          resimg: "", // 上传成功，后台返回的路径
          // autoCropWidth:200,
          // autoCropHeight: 150,
          // uploaddata: {
          //   bucketType:1,
          // },
          headers: {
            token: getToken(),
          },
        };
      },
    },
  },
  data() {
    return {
      uploaddata: {
        bucketType: 1,
      },
      uploadurl: process.env.VUE_APP_BASE_API + "/api/out/minio/upload",
      fileList: [],
      cropperImg: "", // 需要裁剪的图片
      showCropper: false, // 是否显示裁剪框
      uploadFile: "", // 裁剪后的文件
    };
  },
  methods: {
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = (e) => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("blobToBase64 error"));
        };
      });
    },
    //
    dataURLtoFile: function (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    blobToFile: function (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date();
      theBlob.name = fileName;
      return theBlob;
    },
    // submit 之后会触发此方法
    httpRequest(request) {
      loading.start(); //
      console.log(request)
      const { action, data, filename } = request;
      // 新建formDate对象
      let formData = new FormData();
      const params = this.uploaddata;
      for (let key in params) {
        formData.append(key, params[key]);
      }
      // 文件单独push,第三个参数指定上传的文件名
      let files = new window.File([this.uploadFile], request.file.name);
      console.log(files);
      formData.append(filename, files, request.file.name);
      console.log(formData, '传了啥')
      let time = Date.now();// 请求头他token跟签名用
      let obj = { token: Decrypt(getToken()), timestamp: time }
      axios({
        url: action,
        method: "post",
        data: formData,
        timeout: 200000, // 防止文件过大超时
        headers: {
          'signature': SHA256('timestamp' + time + process.env.VUE_APP_BASE_signature).toString(),
          'timestamp': time,
          'Token': Encrypt(JSON.stringify(obj)),
        },
      })
        .then((res) => {
          loading.close();
          console.log(res);
          if (res.data.status_code == 200) {
            this.$message.success("图片上传成功");
            this.uploadimg.resimg = res.data.data; // 上传成功后展示的图片
             console.log(this.uploadimg.resimg)
            this.showCropper = false;
          }
        })
        .catch((err) => {
          loading.close();
          console.log(err);
        });
    },
    // 选择文件
    selectChange(file) {
      const { raw } = file;
      this.openCropper(raw);
    },
    /**
     * @param {file} 上传的文件
     */
    openCropper(file) {
      var files = file;
      let isLt5M = files.size > 2 << 20;
      if (isLt5M) {
        this.$message.error("请上传2M内的图片");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
          console.log(data, '应该一样的')
        } else {
          data = e.target.result;
        }
        this.cropperImg = data;
      };
      // 转化为base64
      // reader.readAsDataURL(file);
      // 转化为blob
      reader.readAsArrayBuffer(files);
      this.showCropper = true;
    },
    // 上传图片
    uploadImg(file) {
      this.uploadFile = file;
      this.$refs.fileUpload.submit();
    },
    // 更新图片
    updateCropper() {
      this.fileList = [];
      this.$refs.fileUpload.$children[0].$el.click();
    },
    // 关闭窗口
    closeDialog() {
      this.fileList = [],
        this.uploadFile = null,
        this.showCropper = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.UploadImg {
  .video-image {
    display: flex;

    figure {
      width: 100px;

      img {
        width: 100%;
        display: block;
      }
    }
  }
}
</style>